import {getElement} from "../modules/helpers.js";
import {compareSwiper} from "./productPageSliders.js";
import {productPage} from "../modules/elements.js";
import {productToCart} from "./productItemPage.js";

export default function productPageCompare() {
    const compareSection = getElement('.section__product-item-compare');
    if (compareSection) {
        compareSwiper();
        fixCompareItemHeight(compareSection)
        fixCompareItemWidth(compareSection);

        window.addEventListener('resize', () => {
            setTimeout(() => {
                fixCompareItemWidth(compareSection);
            }, 350)
        })
        if (compareSection.querySelector('.compare-item__main')) {
            compareSection.querySelector('.compare-item__main').querySelector('[data-cart]').dataset.text = compareSection.querySelector('.compare-item__main').querySelector('[data-cart]').innerHTML
            compareSection.querySelector('.compare-item__main').querySelector('[data-cart]').addEventListener('click', () => {
                let quantity = productPage.querySelector('[data-product-quantity]').dataset.productQuantity
                document.dispatchEvent(new CustomEvent('uarm_addToCart', {
                    detail: {
                        id: productToCart(productPage), quantity: +quantity,
                        el: compareSection.querySelector('.compare-item__main').querySelector('[data-cart]')
                    }
                }));
            })

        }

    }
}


function fixCompareItemWidth(el) {
    let slideWidth = null;
    if (!el.querySelector('.compare-item__main')) return;
    el.querySelectorAll('.compare-item').forEach(compareItem => {
        if (!compareItem.classList.contains('compare-item__main')) {
            return slideWidth = compareItem.offsetWidth;
        }
    })
    el.querySelector('.compare-item__main').style.width = `${slideWidth}px`;

}

function fixCompareItemHeight(el) {
    let items = []
    el.querySelectorAll('.compare-item').forEach((compareItem) => {
        let obj = {};
        compareItem.querySelectorAll('.list__item').forEach((item, i) => {
            obj[i] = item.scrollHeight;
        })
        items = [obj, ...items]
    })

    let val = items[0]
    items.forEach(item => {
        for (let key in item) {
            if (val[key] < item[key]) {
                val[key] = item[key]
            }
        }

    })

    el.querySelectorAll('.compare-item').forEach(compareItem => {
        compareItem.querySelectorAll('.list__item').forEach((item, i) => {
            compareItem.querySelectorAll('.list__item')[i].style.height = `${val[i]}px`
        })
    })

}

export {fixCompareItemWidth, fixCompareItemHeight}